import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  SimpleChanges,
  ViewChild,

} from '@angular/core';
import { VehicleService } from '../vdms_core/services/api/vehicle.service';

import { AppControllerService } from '../vdms_core/controller/app.controller';
import { Router } from '@angular/router';
import { ExcelFileDownloadServices } from '../vdms_shared/utils/excelDownload.services';
import { DataService } from '../vdms_core/services/vehicle/vehicle.data.services';
import { StringToDateAndRenewalPipe } from '../vdms_shared/pipes/renewal.status';
import { AwsS3BucketService } from '../vdms_core/services/awsS3Bucket/aws-s3-bucket.service';
import { FormControl, Validators } from '@angular/forms';
import { ValueCheckingPipe } from '../vdms_shared/pipes/value-checking.pipe';
import { FuelcardService } from '../vdms_core/services/api/fuelcard.service';
import { GcsBucketService } from '../vdms_core/services/gcsBucket/gcs.service';

@Component({
  selector: 'app-assigned-cars',
  templateUrl: './assigned-cars.component.html',
  styleUrls: ['./assigned-cars.component.css'],

})
export class AssignedCarsComponent {
  @Input() inputAssignVehicle: any = [];
  @Output() viewDetails: EventEmitter<any> = new EventEmitter();

  //finduserData: RncUsersModel;
  // Pagination settings
  // pageSizeOptions: number[] = [25, 50, 75, 100];
  pageSize: number = 10;
  // pageIndex: number = 0;
  activePage: number = 1;
  //noOfItems = 10;

  vehicles = [ // Sample vehicle data
    { id: 1, name: 'Car 1' },
    { id: 2, name: 'Car 2' },
    { id: 3, name: 'Car 3' },
    { id: 4, name: 'Car 4' },
    { id: 5, name: 'Car 5' },
    { id: 6, name: 'Car 6' },
    { id: 7, name: 'Car 7' }
  ];



  /*************************************************************************
   * FILTER VARIABLE DECLARATION
   ************************************************************************/
  empRnIdFilterModel: any = new Array();
  empNameFilterModel: any = new Array();

  vehicleFilterModel: any = new Array();
  agencyFilterModel: any = new Array();
  carMakeFilterModel: any = new Array();
  carModelFilterModel: any = new Array();
  carFuelFilterModel: any = new Array();
  driverNameFilterModel: any = new Array();
  driverContactFilterModel: any = new Array();
  carTypeFilterModel: any = new Array();
  allocationDateFilterModel: any = new Array();
  insuranceFilterModel: any = new Array();
  leaseFilterModel: any = new Array();
  fuelFilterModel: any = new Array();


  empRnIdFilterData: any = [];
  empNameFilterData: any = [];
  vehicleFilterData: any = [];
  agencyFilterData: any = [];
  carMakeFilterData: any = [];
  carModelFilterData: any = [];
  carFuelFilterData: any = [];
  driverNameFilterData: any = [];
  driverContactFilterData: any = [];
  carTypeFilterData: any = [];
  allocationDateFilterData: any = [];
  insuranceFilterData: any = [];
  leaseFilterData: any = [];
  fuelFilterData: any = ["YES", "NO"];


  columnfilter = {
    user_rn: {
      singleSelection: false,
      idField: "user_rn",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    name: {
      singleSelection: false,
      idField: "user_name",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Employee Name.",
    },
    driver_name: {
      singleSelection: false,
      idField: "driver_name",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Driver Name.",
    },
    driver_mobile: {
      singleSelection: false,
      idField: "driver_mobile",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Driver Mobile.",
    },
    veh_reg_id: {
      singleSelection: false,
      idField: "veh_reg_id",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Vehicle No.",
    },
    angency_name: {
      singleSelection: false,
      idField: "agencyName",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Agency Name.",
    },
    fuel_card: {
      singleSelection: false,
      idField: "fuel_card",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Fuel Card.",
    },
    car_make: {
      singleSelection: false,
      idField: "car_make",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Car Make.",
    },
    car_model: {
      singleSelection: false,
      idField: "car_model",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Car Model.",
    },
    fuel_type: {
      singleSelection: false,
      idField: "fuel_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Fuel Type.",
    },
    car_type: {
      singleSelection: false,
      idField: "car_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Car Type.",
    },
    policy_no: {
      singleSelection: false,
      idField: "policy_no",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Policy No.",
    },
    lease_to: {
      singleSelection: false,
      idField: "lease_to",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Lease To.",
    },
  }

  // sortKey: string = "car_make"; //set default
  // sortReverse: boolean = false;
  filteredVehicles: any[] = [];  // Filtered vehicles list

  returnCarData: any;
  filesUploadArray: any = [];
  uploadedReturnAttachment: any = [];
  @ViewChild('closeModalBtn') closeModalBtn: ElementRef;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  returnDate: FormControl = new FormControl('', Validators.required);

  sortKey: string = 'user_name';
  sortReverse: boolean = false;

  constructor(
    public vehicleService: VehicleService,
    public appControllerService: AppControllerService,
    public router: Router,
    public excelFileDownloadServices: ExcelFileDownloadServices,
    public dataService: DataService,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    private stringToDateAndRenewalPipe: StringToDateAndRenewalPipe,
    private valueCheckingPipe: ValueCheckingPipe,
    private awsS3BucketService: AwsS3BucketService,
    private fuelCardService: FuelcardService,
    public GcsBucketService: GcsBucketService
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inputAssignVehicle && Array.isArray(changes.inputAssignVehicle.currentValue)) {
      console.log('ASSIGNED_CAR', this.inputAssignVehicle);
      this.filteredVehicles = [...this.inputAssignVehicle];
      console.log('filteredVehicles', this.filteredVehicles)
      this.initializeFilterData(true);
      //this.updatePaginatedData();
    }
  }

  ngAfterViewInit() {
    if (!this.inputAssignVehicle) {
      setTimeout(() => {
        if (Array.isArray(this.inputAssignVehicle) && this.inputAssignVehicle.length > 0) {
          console.log('ASSIGNED_CAR', this.inputAssignVehicle);
          this.initializeFilterData(true);
        }
      }, 0);
    }
  }

  editRow(mode: any, record: any) {
    // Edit action
    console.log('EDIT_ROW', record);

    // Explicitly define the NavigationExtras to include state
    // const navigationExtras: NavigationExtras = {
    //   state: { record }
    // };
    // this.router.navigate(['/pages/addVehicle'], navigationExtras);
    //this.router.navigate(['/addVehicle'], { state: { record } });

    // Using the service to pass data
    record.mode = mode
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/addVehicle']);



  }

  viewRow(mode: any, record: any) {
    // Edit action
    console.log('VIEW_ROW', record);

    // Explicitly define the NavigationExtras to include state
    // const navigationExtras: NavigationExtras = {
    //   state: { record }
    // };
    // this.router.navigate(['/pages/addVehicle'], navigationExtras);
    //this.router.navigate(['/addVehicle'], { state: { record } });

    // Using the service to pass data
    record.mode = mode
    this.dataService.setRecord(record);
    //this.router.navigate(['/pages/addVehicle']);
    this.router.navigate(['/assign_car']);
  }

  deleteRow(row: any) {
    // Delete action
  }



  /*************************************************************************
   * FILTER FUNCTION DECLARATION
   ************************************************************************/

  private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }

    // if (value != null) {
    //   const lowerCaseValue = value.toLowerCase(); // Convert the new value to lower case
    //   const isDuplicate = arr.some(item => item.toLowerCase() === lowerCaseValue); // Check for duplicates (case-insensitive)

    //   if (!isDuplicate) {
    //     arr.push(value); // Add the value only if it's not a duplicate
    //   }
    // }
  }

  initializeFilterData(isData: boolean) {
    console.log('initializeFilterData')
    // Clear the filter data arrays
    // this.empRnIdFilterData=[];
    // this.carMakeFilterData = [];
    // this.carModelFilterData = [];

    this.empRnIdFilterData = [];
    this.empNameFilterData = [];
    this.vehicleFilterData = [];
    this.agencyFilterData = [];
    this.carMakeFilterData = [];
    this.carModelFilterData = [];
    this.carFuelFilterData = [];
    this.carTypeFilterData = [];
    // this.allocationDateFilterData= [];
    this.insuranceFilterData = [];
    this.leaseFilterData = [];

    // const insuranceStatus = this.stringToDateAndRenewalPipe.transform(dSheets.policy_to);
    // const leaseStatus = this.stringToDateAndRenewalPipe.transform(dSheets.lease_to);
    // Populate the filter data arrays
    for (const item of this.inputAssignVehicle) {
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(item.policy_to);
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(item.lease_to);

      this.pushIfValid(this.empRnIdFilterData, item.user_name);
      this.pushIfValid(this.empNameFilterData, item.name);
      this.pushIfValid(this.vehicleFilterData, item.veh_reg_id);
      this.pushIfValid(this.agencyFilterData, item.agencyName);
      this.pushIfValid(this.driverNameFilterData, item.driver_name);
      this.pushIfValid(this.driverContactFilterData, item.driver_mobile);
      // this.pushIfValid(this.vehicleFilterData, item.veh_reg_id);
      this.pushIfValid(this.carMakeFilterData, item.car_make);
      this.pushIfValid(this.carModelFilterData, item.car_model);
      this.pushIfValid(this.carFuelFilterData, item.fuel_type);
      this.pushIfValid(this.carTypeFilterData, item.car_type);
      // this.pushIfValid(this.allocationDateFilterData, item.car_make);
      this.pushIfValid(this.insuranceFilterData, `${insuranceStatus.status}`);
      this.pushIfValid(this.leaseFilterData, `${leaseStatus.status}`);
      this.pushIfValid(this.leaseFilterData, `${leaseStatus.status}`);
    }



    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.empRnIdFilterData = [...this.empRnIdFilterData];
      this.empNameFilterData = [...this.empNameFilterData];
      this.driverNameFilterData = [...this.driverNameFilterData];
      this.driverContactFilterData = [...this.driverContactFilterData];
      this.vehicleFilterData = [...this.vehicleFilterData];
      this.agencyFilterData = [...this.agencyFilterData];
      this.carMakeFilterData = [...this.carMakeFilterData];
      this.carModelFilterData = [...this.carModelFilterData];
      this.carFuelFilterData = [...this.carFuelFilterData];
      this.carTypeFilterData = [...this.carTypeFilterData];
      // this.allocationDateFilterData= [...this.carMakeFilterData];
      this.insuranceFilterData = [...this.insuranceFilterData];
      this.leaseFilterData = [...this.leaseFilterData];
    };

    console.log('filter data added', this.carMakeFilterData);
    console.log('filter data added', this.carModelFilterData);

    if (isData) {
      // Update immediately when `isData` is true
      updateDropdownData();
    } else {
      // Use Angular's `zone` to avoid ExpressionChangedAfterItHasBeenCheckedError
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          this.zone.run(() => {
            updateDropdownData();
          });
        }, 15000);
      });
    }
  }


  onFilterChange() {
    console.log('onfilterchange')
    if (!Array.isArray(this.inputAssignVehicle)) {
      this.filteredVehicles = [];
      return;
    }
    this.filteredVehicles = this.inputAssignVehicle.filter(vehicle => {

      console.log('ASSIGNED_vehicle', vehicle)
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(vehicle.policy_to).status;
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(vehicle.lease_to).status;
      const fuelCardStatus = this.valueCheckingPipe.transform(vehicle.fuel_card_id).status;

      // // Helper function to check if a value matches the filter
      const matchesFilter = (filter: any[], value: any) =>
        !filter.length || filter.includes(value);

      this.empRnIdFilterData = [...this.empRnIdFilterData];
      this.empNameFilterData = [...this.empNameFilterData];
      this.driverNameFilterData = [...this.driverNameFilterData];
      this.driverContactFilterData = [...this.driverContactFilterData];
      this.vehicleFilterData = [...this.vehicleFilterData];
      this.agencyFilterData = [...this.agencyFilterData];
      this.carMakeFilterData = [...this.carMakeFilterData];
      this.carModelFilterData = [...this.carModelFilterData];
      this.carFuelFilterData = [...this.carFuelFilterData];
      this.carTypeFilterData = [...this.carTypeFilterData];
      this.insuranceFilterData = [...this.insuranceFilterData];
      this.leaseFilterData = [...this.leaseFilterData];
      this.fuelFilterData = [...this.fuelFilterData];

      // Checking if the vehicle matches all filters
      const matchEmpId = matchesFilter(this.empRnIdFilterModel, vehicle.rn_id);
      const matchEmpname = matchesFilter(this.empNameFilterModel, vehicle.name);
      const matchDrivername = matchesFilter(this.driverNameFilterModel, vehicle.driver_name);
      const matchDriverContact = matchesFilter(this.driverContactFilterModel, vehicle.driver_mobile);
      const matchVehicle = matchesFilter(this.vehicleFilterModel, vehicle.veh_reg_id);
      const matchAgency = matchesFilter(this.agencyFilterModel, vehicle.agencyName);
      const matchCarMake = matchesFilter(this.carMakeFilterModel, vehicle.car_make);
      const matchCarModel = matchesFilter(this.carModelFilterModel, vehicle.car_model);
      const matchCarFuel = matchesFilter(this.carFuelFilterModel, vehicle.fuel_type);
      const matchCarType = matchesFilter(this.carTypeFilterModel, vehicle.car_type);
      const matchInsurance = matchesFilter(this.insuranceFilterModel, insuranceStatus);
      const matchLease = matchesFilter(this.leaseFilterModel, leaseStatus);
      const matchFuelCard = matchesFilter(this.fuelFilterModel, fuelCardStatus);

      // Return true only if all criteria match
      return (
        matchEmpId &&
        matchEmpname &&
        matchDrivername &&
        matchDriverContact &&
        matchVehicle &&
        matchCarMake &&
        matchCarModel &&
        matchCarFuel &&
        matchCarType &&
        matchInsurance &&
        matchLease &&
        matchFuelCard &&
        matchAgency
      );


      //   const matchEmpId = !this.empRnIdFilterModel.length ||
      //     this.empRnIdFilterModel.includes(vehicle.user_rn);
      //   const matchEmpname = !this.empNameFilterModel.length ||
      //     this.empNameFilterModel.includes(vehicle.user_name);
      //   const matchVehicle = !this.vehicleFilterModel.length ||
      //     this.vehicleFilterModel.includes(vehicle.veh_reg_id);
      //   const matchCarMake = !this.carMakeFilterModel.length ||
      //     this.carMakeFilterModel.includes(vehicle.car_make);
      //   const matchCarModel = !this.carModelFilterModel.length ||
      //     this.carModelFilterModel.includes(vehicle.car_model);
      //   const matchCarFuel = !this.carFuelFilterModel.length || 
      //                        this.carFuelFilterModel.includes(vehicle.fuel_type);
      //   const matchCarType = !this.carTypeFilterModel.length ||
      //     this.carTypeFilterModel.includes(vehicle.car_type);
      //   // const matchAllocationDate = !this.allocationDateFilterModel.length || 
      //   //                      this.allocationDateFilterModel.includes(vehicle.car_model);
      //   const matchInsurance = !this.insuranceFilterModel.length ||
      //     this.insuranceFilterModel.includes(insuranceStatus);
      //   const matchLease = !this.leaseFilterModel.length ||
      //     this.leaseFilterModel.includes(leaseStatus);
      //  // this.cdRef.detectChanges();
      //   return matchCarFuel && matchCarModel&& matchEmpId && matchEmpname && matchVehicle && matchCarMake && matchCarType && matchInsurance && matchLease;
    });

    // if (filtered.length === 0) {
    //   alert('No matching vehicles found!')
    // } 
    console.log('checkTYPEOF', typeof this.filteredVehicles)
    // if(filtered.length > 0){
    //   console.log('checkTYPEOF__', filtered)
    //   this.filteredVehicles.push(filtered)
    //   console.log('checkTYPEOF', typeof  this.filteredVehicles)
    // }
    // alert('No matching vehicles found!'+this.filteredVehicles.length);
  }

  // onFilterChange() {
  //   let filtered = [...this.inputAssignVehicle];

  //   if (this.empRnIdFilterModel.length > 0) {
  //     const selectedIds = this.empRnIdFilterModel.map(item => item.veh_reg_id);
  //     filtered = filtered.filter(v => selectedIds.includes(v.veh_reg_id));
  //   }

  //   if (this.carMakeFilterModel.length > 0) {
  //     const selectedMakes = this.carMakeFilterModel.map(item => item.car_make);
  //     filtered = filtered.filter(v => selectedMakes.includes(v.make));
  //   }

  //   if (this.carModalFilterModel.length > 0) {
  //     const selectedModels = this.carModalFilterModel.map(item => item.car_model);
  //     filtered = filtered.filter(v => selectedModels.includes(v.model));
  //   }

  //   this.inputAssignVehicle = filtered;
  // }


  returnToAdmin(car: any) {
    this.returnCarData = car;
    console.log(this.returnCarData, "this.returnCarData:::::::::::");

  }

  onFileChange(event: any) {
    const files: FileList = event.target.files;

    if (files.length > 0) {
      const file: File = files[0];
      for (let i = 0; i < files.length; i++) {
        this.filesUploadArray.push(this.renamedFileName(files[i], "Vehicle_Return"));
      }
      console.log('filesUploadArray', this.filesUploadArray);
    }
  }

  renamedFileName(file: File, namePrefix: string) {
    const vehicleNumber = this.returnCarData.veh_reg_id;
    const timestamp = new Date().getTime(); // Get current Unix timestamp
    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts.pop(); // Extract the file extension
    const renamedFileName = `${namePrefix}_${vehicleNumber}_${timestamp}.${fileExtension}`; // Append timestamp and original file extension to the file name
    const renamedFile = new File([file], renamedFileName, { type: file.type });
    return renamedFile;
  }

  async returnCar() {
    if (this.filesUploadArray.length) {
      var urlPath: any;
      var selectedFileObj;
      var inx: any;
      let result: any;
      this.filesUploadArray.forEach((file, index) => {
        selectedFileObj = file;
        inx = index;

        const fileNameParts = file.name.split('_');
        console.log('fileNameParts', fileNameParts);
        const folderName = fileNameParts[0]; // Extract the folder name from the file name
        console.log('folderName', folderName);
        // const awsImagePath
        urlPath = `vdms/${folderName}/${file.name}`;

        console.log('awsImagePath', urlPath);
      });

      try {
        result = await this.GcsBucketService
          .uploadFile(selectedFileObj, urlPath)
          .then((res) => {
            console.log('Upload_success', res.body.bucketPath);

            console.log('get_key', res.body.bucketPath);

            const urlNameParts = res.body.bucketPath.split('/');
            console.log('urlNameParts', urlNameParts);
            const folderName = urlNameParts[1]; // Extract the folder name from the url name
            console.log('URLName', folderName);

            var obj: any = {
              url: res.body.bucketPath,
              uploaded_on: new Date().toISOString(),
            };
            this.uploadedReturnAttachment.push(obj);
            this.filesUploadArray.splice(inx, 1);
            this.returnCar();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      this.saveReturnCar();
    }
  }

  async saveReturnCar() {
    let dateFormat = require("dateformat");
    let vehicle_return_submission_date = dateFormat(new Date(), "yyyy-mm-dd");
    let returnCarObj = {
      id: this.returnCarData.assigned_id,
      vehicle_return_attachments: this.uploadedReturnAttachment,
      car_return_date: this.returnDate.value,
      vehicle_return_submission_date: vehicle_return_submission_date,
    }
    this.vehicleService.returnAssignedCar(returnCarObj).then((result) => {
      this.updateVehicleStatus();
    });
  }

  updateVehicleStatus() {
    let vehicleObj = {
      id: this.returnCarData.id,
    };
    this.vehicleService.updateVehicleStatus(vehicleObj).then((result) => {
      this.updateDaVechicleMaster();
    });
  }

  updateDaVechicleMaster() {
    if(this.returnCarData.da_vehicle_master_id) {
      let vehicleObj = {
        id: this.returnCarData.da_vehicle_master_id,
        ex_data: "UNASSIGN"
      }
      this.vehicleService.updateDaVehicleMaster(vehicleObj).then((result) => {
        if (this.returnCarData.fuel_card_id) {
          this.updateFuelCardStatus();
        } else {
          this.closeModal();
        }
      });
    } else {
      if (this.returnCarData.fuel_card_id) {
          this.updateFuelCardStatus();
      } else {
          this.closeModal();
      }

    }
  }

  updateFuelCardStatus() {
    let fuelCardObj = {
      id: this.returnCarData.fuel_card_id
    }

    this.fuelCardService.updateFuelMasterCardStatus(fuelCardObj).then((_result) => {
      this.closeModal();
    });
  }

  closeModal() {
    this.resetModal();
    this.closeModalBtn.nativeElement.click();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  resetModal() {
    this.returnDate.reset();
    this.uploadFile.nativeElement.value = null;
    this.filesUploadArray = [];
  }

  viewData(vehicleData: any) {
    this.viewDetails.emit(vehicleData);
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }
  }

}
